import { restRequest } from 'config/rest-client';

type LostPasswordPayload = {
  username: string;
  secret: string;
  password: string;
  confirm: string;
};

export const lostPasswordFirstStep = ({
  username, secret, password, confirm,
}: LostPasswordPayload) => restRequest('/users/password', {
  method: 'POST',
  body: {
    username, secret, password, confirm,
  },
});

export const sendEmailAccessLink = (email: string) => restRequest('/users/access', {
  method: 'POST',
  body: { email },
});